import { useEffect, useReducer, useState } from 'react'

export function useNetdaniaData (instruments, pollingInterval) {
  function cancelInstrumentsUpdate () {}

  const [store, dispatch] = useReducer(
    (s, a) => {
      switch (a.type) {
        case 'ONPRICEUPDATE':
          if (a.payload.latest === 'N/A') {
            return s
          }
          return {
            ...s,
            [a.payload.id]: {
              ...a.payload,
              name:
                a.payload.name !== 'N/A'
                  ? a.payload.name
                  : s[a.payload.id].name,
              QUOTE_CLOSE:
                a.payload.QUOTE_CLOSE !== 'N/A'
                  ? a.payload.QUOTE_CLOSE
                  : s[a.payload.id].QUOTE_CLOSE
            }
          }
        case 'ONERROR':
          return s
        default:
          return s
      }
    },
    {},
    a => a
  )
  const [requests, setRequests] = useState([])
  useEffect(() => {
    var connectionConfig = {
      pollingInterval: pollingInterval, //milliseconds
      host: '//balancer.netdania.com/StreamingServer/StreamingServer',
      failoverHosts: [
        '//balancer-cro.netdania.com/StreamingServer/StreamingServer',
        '//81.89.26.212/StreamingServer/StreamingServer',
        '//109.166.243.196/StreamingServer/StreamingServer'
      ],
      behavior: NetDania.JsApi.ConnectionType.AUTO, //POLLING, LONGPOLLING, AUTO
      type: 1 //the server response format: JSONP
    }

    //create a json connection object
    let connection = new NetDania.JsApi.JSONConnection(connectionConfig)
    setRequests(
      instruments.map(i => {
        var req = NetDania.JsApi.Request.getReqObjPrice(
          i.symbol,
          i.provider,
          true,
        )
        connection.AddRequest(req)
        return req
      })
    )

    //these instruments will be requested from the server after the connection to the server has been succesfully
    connection.Connect()
    connection.Flush()

    connection.addListener(NetDania.JsApi.Events.ONPRICEUPDATE, function (
      monitorPriceResponse
    ) {
      //raw json data received from the server
      try {
        const ts = monitorPriceResponse.get(
          NetDania.JsApi.Fields.QUOTE_TIME_STAMP
        )
        const timestamp = ts === 'N/A' ? ts : new Date(ts * 1000)
        let payload = {
          timestamp,
          name: monitorPriceResponse.get(NetDania.JsApi.Fields.QUOTE_NAME),
          fullName: monitorPriceResponse.get(
            NetDania.JsApi.Fields.QUOTE_FULL_NAME
          ),
          latest: monitorPriceResponse.get(NetDania.JsApi.Fields.QUOTE_LAST),
          QUOTE_CLOSE: monitorPriceResponse.get(
            NetDania.JsApi.Fields.QUOTE_CLOSE
          ),
          id: monitorPriceResponse.id
        }
        dispatch({ type: 'ONPRICEUPDATE', payload: payload })
      } catch (ex) {
        console.log(ex)
      }
    })

    //event triggered when an error is received
    connection.addListener(NetDania.JsApi.Events.ONERROR, function(ev) {
      dispatch({ type: 'ONERROR', payload: ev })
    })
    return cancelInstrumentsUpdate
  }, [])
  return [store, requests]
}
